<ng-container *ngIf="!!get && !!form" [formGroup]="form">
    <tt-select
        *ngIf="get.show_oh_head_businessco_no !== '0'"
        ttLabel="businessco"
        formControlName="businessco_no"
        [ttData]="companies"
        ttDataId="businessco_no"
        ttDataName="company_name"
        ttReadonly
    ></tt-select>
    <tt-select
        *ngIf="get.show_oh_head_reg_by_portal_user_keyno !== '0'"
        ttLabel="reg_by_portal_user_keyno"
        formControlName="reg_by_portal_user_keyno"
        [ttData]="portalUsers"
        ttDataId="item_id"
        ttDataName="item_name"
    ></tt-select>
    <tt-input *ngIf="get.show_oh_head_ordertype_id !== '0'" ttLabel="ordertype" formControlName="ordertype_name" ttReadonly></tt-input>
    <tt-order-head-convert-to-order-button
        *ngIf="get.ordertype_id == '1' && get.setting_oh_show_dynamic_special !== '1'"
        [get]="get"
        [orderHeadProvider]="orderHeadProvider"
        icon="fas fa-plus"
        (converted)="converted.emit()"
    ></tt-order-head-convert-to-order-button>
    <tt-input *ngIf="get.show_original_order_internal_no === '1'" ttLabel="original_order_internal_no" [(ttModel)]="get.original_order_internal_no" ttReadonly>
        <tt-form-field-button buttons *ngIf="get.original_order_internal_no > '0'" ttGoto="orderhead" [ttGotoParms]="{ order_internal_no: get.original_order_internal_no }"></tt-form-field-button>
    </tt-input>
    <tt-date *ngIf="get.show_oh_head_order_date !== '0'" ttLabel="order_date" formControlName="order_date"></tt-date>
    <tt-checkbox *ngIf="get.setting_show_oh_head_verified !== '0'" ttLabel="oh_verified" formControlName="verified"></tt-checkbox>
    <tt-input *ngIf="get.show_oh_head_order_order_no !== '0'" ttLabel="orderhead_order_order_no" formControlName="order_order_no" ttReadonly></tt-input>
    <tt-input *ngIf="get.show_oh_head_orderstatus_name !== '0'" ttLabel="orderhead_orderstatus_name" formControlName="orderstatus_name" ttReadonly></tt-input>
    <tt-input *ngIf="get.setting_show_oh_head_order_offer_no !== '0' && !(get.order_offer_no === '' && +get.order_order_no > 0)" ttLabel="order_offer_no" formControlName="order_offer_no" ttReadonly></tt-input>
    <tt-select
        *ngIf="get.show_oh_head_ordermethod_id !== '0'"
        ttLabel="ordermethod"
        formControlName="ordermethod_id"
        [ttData]="orderMethods"
        ttDataId="ordermethod_id"
        ttDataName="ordermethod_name"
    ></tt-select>
    <tt-select
        *ngIf="get.show_oh_head_stockplace_id !== '0'"
        ttLabel="stockplace"
        formControlName="stockplace_id"
        [ttData]="stockplaces"
        ttDataId="stockplace_id"
        ttDataName="stockplace_name"
    ></tt-select>
    <tt-select *ngIf="get.show_oh_head_seller_no !== '0'" ttLabel="seller" formControlName="seller_no" [ttData]="sellers" ttDataId="item_id" ttDataName="item_name"></tt-select>
    <tt-input *ngIf="get.setting_show_oh_head_purch_internal_no_from !== '0' && +get.purch_internal_no_from > 0" ttLabel="purch_internal_no_from" formControlName="purch_internal_no_from" ttReadonly></tt-input>
    <tt-input *ngIf="get.setting_show_oh_head_consernorder_order_no !== '0' && +get.consernorder_order_no > 0" ttLabel="consernorder_order_no" formControlName="consernorder_order_no" ttReadonly>
        <ng-container buttons>
            <tt-form-field-button
                ttIcon="fas fa-chevron-right"
                ttGoto="orderhead"
                [ttGotoParms]="{ order_internal_no: get.consernorder_internal_no }"
                ttTooltip="goto_orderhead"
                [ttTranslateTooltip]="true"
            ></tt-form-field-button>
        </ng-container>
    </tt-input>
    <tt-select
        *ngIf="get.show_oh_head_department_id !== '0'"
        ttLabel="department"
        formControlName="department_id"
        [ttData]="departments"
        ttDataId="department_id"
        ttDataName="department_name"
    ></tt-select>
    <tt-input *ngIf="get.show_oh_head_orderhead_note1 !== '0'" ttLabel="orderhead_note1" formControlName="orderhead_note1"></tt-input>
    <tt-input *ngIf="get.show_oh_head_orderhead_note2 !== '0'" ttLabel="orderhead_note2" formControlName="orderhead_note2"></tt-input>
    <tt-input *ngIf="get.show_oh_head_orderhead_note3 !== '0'" ttLabel="orderhead_note3" formControlName="orderhead_note3"></tt-input>
</ng-container>
